/**
 * Formats a number with 2 decimals and a comma separator (e.g. 12.5 → "12,50").
 *
 * Intentionally NOT `toLocaleString`/`parseFloatCurrency`: those insert a
 * thousands separator ("1.234,56"), which would change the output for
 * values >= 1000 compared to the historical inline `toFixed(2).replace`.
 */
export function formatDecimalBR(value: number): string {
  return value.toFixed(2).replace(".", ",")
}
